import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ContactListRes } from "../../types/ResType";

const initialState: ContactListRes = {
  data: [],
  status: false,
  message: "",
  toast: false,
};

const ContactListSlice = createSlice({
  name: "contactList",
  initialState,
  reducers: {
    updateSpesificContactList(
      state,
      action: PayloadAction<Partial<ContactListRes>>,
    ) {

      return { ...state, ...action.payload };
    },
    updateContactListRes(state, action: PayloadAction<ContactListRes>) {

      return action.payload;
    },
  },
});

export default ContactListSlice.reducer;
export const { updateSpesificContactList, updateContactListRes } =
  ContactListSlice.actions;
